<template lang="html">
  <div class="result-focus" ref="stage">
    <div class="result-focus-main">
      <h3>务必关注【才博】公众号进行学习！</h3>
      <div class="result-focus-main-qrcode">
        <img class="result-focus-qr" src="http://edu-wps-cn.ks3-cn-beijing.ksyun.com/static_file/pictures/qrcode/688734ea69c12c7a8ef9d8a6df5573f2.png"/>
      </div>
    </div>
  </div>
</template>

<script>
import groupImgUrlData from '../../assets/images/sign-up-result-group_guide_steps.png'
import getWXData from '../../assets/images/get_wx.png'
import getWXSubData from '../../assets/images/get_wx_sub.png'
import api from '@edu-fe/api'
import html2canvas from 'html2canvas'

export default {
  name: 'ResultFocus',

  props: ['hasCourseGroup', 'wxinfo'],

  data () {
    return {
      open: false,
      show: false,
      isIOS: false,
      groupLessImgUrl: 'http://cdn.iciba.com/www/eduwx/sign-up-result-guide_steps.png',
      groupImgUrl: groupImgUrlData,
      getWX: getWXData,
      getWXSub: getWXSubData,
      staticQr: '',
      imgSrc: ''
    }
  },

  methods: {
    click () {
      this.open = !this.open
    }
  },

  async created () {
    this.isIOS = /iphone os/i.test(navigator.userAgent)
  },

  async mounted () {
    this.staticQr = 'data:image/png;base64,' + (await api.utils.url2base64('http://edu-wps-cn.ks3-cn-beijing.ksyun.com/static_file/pictures/qrcode/688734ea69c12c7a8ef9d8a6df5573f2.png')()).data
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.canvas {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;

  img {
    height: 100%;
    width: 100%;
  }
}

.result-focus {
  position: relative;
  /*border-top: use(18) solid #F2F2F2;*/
  /*text-align: center;*/
  padding: 0 rem(30);

  &-info {
    padding: rem(40) 0;
    text-align: center;
    font-size: rem(32);
    color: #999999;
  }
  &-main {
    h3 {
      font-size: rem(30);
      font-weight: bolder;
      margin-bottom: rem(40);
      text-align: left;
      &:before {
        content: '1';
        display: inline-block;
        width: rem(36);
        height: rem(36);
        color: white;
        background: url("../../assets/icons/icon-round.png") no-repeat;
        background-size: contain;
        line-height: rem(36);
        text-align: center;
        margin-right: rem(30);
      }
    }
    &-qrcode {
      width: rem(260);
      height: rem(260);
      margin: auto;
    }
    img {
      width: rem(260);
    }
  }
  /*&-text {*/
    /*position: absolute;*/
    /*left: use(200);*/
    /*top: use(320);*/
    /*width: use(350);*/
    /*height: use(70);*/
    /*font-size: use(48);*/
    /*background-color: #fff;*/
    /*color: #000;*/
  /*}*/

  /*&-ios {*/

    /*h3 {*/
      /*color: #F48F00;*/
      /*font-size: rem(38);*/
      /*text-align: center;*/
      /*margin-top: rem(60);*/
      /*margin-bottom: rem(32);*/
    /*}*/

    /*p {*/
      /*color: #999999;*/
      /*font-size: rem(28);*/
      /*text-align: center;*/
      /*margin-bottom: rem(10);*/
    /*}*/

    /*section {*/
      /*height: rem(132);*/
      /*width: rem(400);*/
      /*margin: rem(80) auto;*/
      /*margin-bottom: 0;*/
      /*background-size: 100%;*/
      /*color: #000;*/
      /*font-size: rem(48);*/
      /*font-weight: bold;*/
      /*text-align: center;*/
      /*line-height: rem(132);*/
    /*}*/
  /*}*/

  /*&-qr {*/
    /*&-bg {*/
      /*// position: fixed;*/
      /*// top: 0;*/
      /*// left: 0;*/
      /*z-index: 0;*/
      /*height: 100%;*/
      /*width: 100%;*/
      /*opacity: 0;*/
    /*}*/

    /*position: absolute;*/
    /*left: 0; right: 0;*/
    /*top: rem(230);*/
    /*margin: 0 auto;*/
    /*height: rem(270);*/
    /*width: rem(270);*/
  /*}*/

  /*&-tip {*/
    /*display: block;*/
    /*width: use(418);*/
    /*margin: use(71) auto 0;*/
    /*&-main {*/
      /*width: use(622);*/
      /*margin-bottom: rem(44);*/
    /*}*/
  /*}*/
  /*.bigger {*/
    /*width: rem(410);*/
    /*height: rem(410);*/
    /*top: rem(190);*/
  /*}*/
  // &-button {
  //   margin: use(90) auto 0;
  //   width: use(390);
  //   @include height(60);
  //   background-color: #FFEFD7;
  //   border-radius: use(30);
  //   color: #F48F00;
  //   font-size: use(26);
  //   &-arrow {
  //     display: inline-block;
  //     @include square(18, 10);
  //     margin-left: use(10);
  //     @include relative(-4);
  //     @include rotate();
  //     transition: .3s;
  //     &.on {
  //       @include rotate(180deg);
  //     }
  //   }
  // }
  &-image {
    width: use(489);
    margin: use(40) auto 0;
  }

  &-qr {
    &.bigger {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 99;
      width: 100%;
      opacity: 0;
    }
  }
}
</style>
